import { icons } from '../assets/icons/index'
import { useThemeMode } from '../theme/ThemeModeContext'

export const useThemedIcon = <T extends keyof typeof icons>(name: T) => {
  const { resolvedMode } = useThemeMode()

  const icon = icons[name][resolvedMode]

  // handle SVG module imports
  if (typeof icon === 'object' && 'default' in icon) {
    return icon.default
  }

  return icon
}
